export default {
  appTitle: 'Captin - Local',
  apiUrl: 'https://localhost:8010/api',
  appEnv: 'development',
  isDevelopment: true,
  isStaging: false,
  isProduction: false,
};